import { render, staticRenderFns } from "./QuickBuy.vue?vue&type=template&id=59926d98&"
import script from "./QuickBuy.vue?vue&type=script&lang=js&"
export * from "./QuickBuy.vue?vue&type=script&lang=js&"
import style0 from "./QuickBuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports